export const GET_PAGE_FIXED = 'getPageFixed'
export const GET_PAGE_ADDED = 'getPageAdded'
export const GET_PAGE_PREVIEW = 'getPagePreview'
